import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../../net/http-common";
import { JOB_SERVER_URL } from "../../config";

interface stateType {
  status: "idle" | "loading" | "failed" | "successful";
  properties: {
    rowData: any[];
  };
  taskId: string;
}

const initialState: stateType = {
  status: "idle",
  properties: {
    rowData: [],
  },
  taskId: "",
};

export const fetchHopperResults = createAsyncThunk(
  "hopper/fetchHopperResults",
  async (task_id: string) => {
    try {
      const response = await http.get(
        `${JOB_SERVER_URL}/hopper/results?task_id=${task_id}&as_file=${false}`,
        {
          headers: {
            accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

const hopperSlice = createSlice({
  name: "hopper",

  initialState,
  reducers: {
    setProperties(state, action) {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHopperResults.rejected, (state, action: any) => {
        state.status = "failed";
      })
      .addCase(fetchHopperResults.pending, (state) => {
        state.status = "loading";
      })
      .addCase(
        fetchHopperResults.fulfilled,
        (state: stateType, action: any) => {
          state.properties.rowData = action.payload.results;
          state.taskId = action.payload.task_id;
          state.status = "successful";
        }
      );
  },
});

export const { setProperties } = hopperSlice.actions;
export default hopperSlice.reducer;
